var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"vue-geo-locator"},[_c('button',{class:{'active': _vm.hasGeoLocation},attrs:{"title":_vm.translations.getCurrentLocationText},on:{"click":_vm.geoLocate}},[_c('span',{staticClass:"visually-hidden"},[_vm._v("\n            "+_vm._s(_vm.translations.getCurrentLocationText)+"\n        ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }